module.exports = __webpack_public_path__ + "img/trayectoria.a7f7e7fe.png";